import { useEffect, useState } from 'react'
import Router from 'next/router'

import { preparedIdURL } from 'utils/getURLData'
import { getAxiosSingle } from '../pages/api/axios'
import { URL_LIST } from '../constants/url'
import { ILike } from '../constants/types/common.types'
import { RouterEvents } from 'constants/events'

const useGetLikes = (
  id: string,
  setLikes: ({ likeCount, like }: ILike) => void,
  isNoUpdate?: boolean
) => {
  const [pathname, setPathname] = useState('')

  const listenToPopstate = () => setPathname(preparedIdURL(window.location.pathname))

  useEffect(() => {
    if (isNoUpdate) return
    Router.events.on(RouterEvents.ROUTE_CHANGE_COMPLETE, listenToPopstate)
    return () => {
      Router.events.off(RouterEvents.ROUTE_CHANGE_COMPLETE, listenToPopstate)
    }
  }, [])

  useEffect(() => {
    const getLikes = async () => {
      const query = `${URL_LIST.LIKE}?id=${
        id || pathname || preparedIdURL(window.location.pathname)
      }`
      const result = await getAxiosSingle(query)
      const data = {
        likeCount: result?.likeCount ? String(result.likeCount) : '0',
        like: Boolean(result.like),
      }
      setLikes(data)
    }
    getLikes()
  }, [id, pathname])
}

export default useGetLikes
